import React from 'react'; 
import classes from './MainBackdrop.module.css'

const MainBackdrop = (props) => {
  return (
    <div className={classes.backdrop} onClick={props.onClick}>{props.children}</div>
  )
}

export default MainBackdrop